module.exports = __webpack_public_path__ + "img/new_SGS2.21dfaa4.svg";